

export class ToolTipHeaderSelectAllOutputWithStatus implements IToolTipHeaderSelectAllOutputWithStatus {
    /** The auto-generated id of the tool tip header master master */
    tooltip_header_id!: number;
    /** The tool tip header name  with 255 character limit */
    tooltip_header_name!: string;
    /** Manage status of tool tip header. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IToolTipHeaderSelectAllOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltip_header_id = _data["tooltip_header_id"];
            this.tooltip_header_name = _data["tooltip_header_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ToolTipHeaderSelectAllOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipHeaderSelectAllOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltip_header_id"] = this.tooltip_header_id;
        data["tooltip_header_name"] = this.tooltip_header_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IToolTipHeaderSelectAllOutputWithStatus {
    /** The auto-generated id of the tool tip header master master */
    tooltip_header_id: number;
    /** The tool tip header name  with 255 character limit */
    tooltip_header_name: string;
    /** Manage status of tool tip header. 0 For De-active, 1 For Active */
    status: number;
}

